// extracted by mini-css-extract-plugin
export default {"companyContainer":"EL-z","companyImage":"FL-z","container":"GL-z","heading":"HL-z","darkText":"IL-z","smallHeading":"JL-z","darkBackground":"KL-z","whiteBackground":"LL-z"};